export default {
    namespaced: true,
    state: {
        loading: false,
        endpoint: 'informes/lista-campana',
        campana: [],
        campanaTotal: 0
    },
    mutations: {
        setLoading: (state, payload) => state.loading = payload,
        setCampana: (state, payload) => state.campana = payload ,
        setCampanaTotal: (state, payload) => state.campanaTotal = payload,
        SET_ENDPOINT: (state, payload) => state.endpoint = payload
    },
    getters: {
        endpoint: state => state.endpoint,
        loading: state => state.loading,
        campana: state => state.campana,
    },
    actions: {
        fetch({commit}, payload) {
            this.dispatch('index', payload)
              .then((response) => {
                commit('setCampana', response.datos)
              })
          },
        
         refresh_campana({commit}, payload) {
            commit('setCampana', payload)
        }
    }
}